module.exports = __webpack_public_path__ + "img/icon-warning-polarlow-orange.a39edfa6.svg";